import axios, { AxiosRequestHeaders } from 'axios';
import { remoteConfigGetter } from "../utils/remoteConfig";
import { loginEvent, setEmailAndMobile, setOtpData, setQrData } from "../slices/authSlice";
import { toast } from "react-toastify";
import authService from "./authService";
import { ResponceStatusService } from "../sub";

const globalHeaders: AxiosRequestHeaders = {
    'Content-Type': 'application/json',
    "X-Application-Id": String(process.env.REACT_APP_TV_APPLICATION_ID),
    "X-Stage": String(process.env.REACT_APP_ENV),
}
export const apiFlowBackend = axios.create({
    baseURL: remoteConfigGetter('vortex_url_v2').asString(),
    headers: globalHeaders
});

export const waveBackend = axios.create({
    baseURL: remoteConfigGetter('vortex_url_v2').asString(),
    headers: {
        'Content-Type': 'application/json',
    },
});

function authorizedHeaders(token: string) {
    return { ...globalHeaders, 'Authorization': `Bearer ${token}` }
}
async function update2faPref(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.put('aux/authentication/update2faPref', data, { headers: headers });
}

async function SsoLogin(body: any) {
    return await apiFlowBackend.post('aux/authentication/v2/verifySso', body);
}



async function verifyMfaSSO(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('aux/authentication/submitMfa', data, { headers: headers });
}

async function refreshLogin(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('aux/authentication/refreshLogin', data, { headers: headers });
}

async function getTotalMargin(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('margins/basket', data, { headers: headers });
}

async function getOptionUserPreferences(formValues: any, token: string) {
    var headers = { ...globalHeaders, 'Authorization': "Bearer " + token }
    return await apiFlowBackend.get('aux/user/preferences', { headers: headers });

}
async function setUseroptionPreferences(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return await apiFlowBackend.put('aux/user/preferences', formValues, { headers: headers });
}

async function getHistoricalOHLC(token: string, segmentId: number, accesstoken: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + accesstoken };
    return await apiFlowBackend.get('aux/highLow?token=' + token + "&market_segment_id=" + segmentId, { headers: headers })
}

async function getFutures(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return axios.post(remoteConfigGetter('vortex_url_v2').asString() + 'aux/futurechain', formValues, { headers: headers });
}

async function getStrategies(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return axios.post(remoteConfigGetter('vortex_url_v2').asString() + 'strategies', formValues, { headers: headers });
}

async function getPayOff(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    var aa = remoteConfigGetter('vortex_url_v2').asString()
    return axios.post(remoteConfigGetter('vortex_url_v2').asString() + 'strategies/payoff', formValues, { headers: headers });
}

async function getAvailableFunds(token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return apiFlowBackend.get('user/funds', { headers: headers });
}

async function getBuilderStrategies(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return axios.post(remoteConfigGetter('vortex_url_v2').asString() + 'strategies/build', formValues, { headers: headers });
}



apiFlowBackend.interceptors.response.use(undefined, err => {
    const error = err.response;
    if (error?.status === 401) {
        ResponceStatusService.sendRes({ type: 'FLOW', status: 401 });
    }
    return Promise.reject(err);
});





function setUpSessionData(value: any, mfaType: any, dispatch: any, navigate: any, data: any) {
    let userData = value.data
    if (userData.status === 'success') {
        let newData = { ...data, refreshToken: userData.refreshToken, mfaType: userData.mfa_type, mfaEnabled: userData.mfaEnabled }
        let dataSet = { data: newData, user_id: data.clientCode }
        dispatch(setOtpData(dataSet))
        toast.success(`OTP Verified`)
        const refreshData = { refreshToken: userData.refreshToken, ssoToken: userData.ssoToken, mfaType: userData.mfaType, deviceId: data.deviceId, tradingActive: userData.tradingActive }
        const userModify = { ...userData.data, ...refreshData }

        // login event
        dispatch(setEmailAndMobile({ mobile: null, email: userModify.email }))
        dispatch(loginEvent({ mobile: null, email: userModify.email }))

        authService.saveUserSessionFlow({ user: userModify, refreshData, dispatch })
        if (mfaType === 'otp') navigate("/setTOtp", { replace: true })
        if (mfaType === 'totp') navigate("/tvTerminal", { replace: true });
    }
}

function setUpQrSessionData(value: any, dispatch: any, navigate: any, data: any) {
    let userData = value
    if (userData.status === 'success') {
        let newData = { ...data, refreshToken: userData.refreshToken, mfaType: data.stateData.mfaType, mfaEnabled: userData.mfaEnabled }
        let dataSet = { data: newData, user_id: userData.data.clientCode }
        dispatch(setQrData(dataSet))
        const refreshData = { refreshToken: userData.refreshToken, ssoToken: userData.ssoToken, mfaType: data.stateData.mfaType, deviceId: data.stateData.deviceId, tradingActive: userData.tradingActive }
        const userModify = { ...userData.data, ...refreshData }

        // login event
        dispatch(setEmailAndMobile({ mobile: null, email: userModify.email }))
        dispatch(loginEvent({ mobile: null, email: userModify.email }))

        authService.saveUserSessionFlow({ user: userModify, refreshData, dispatch })
        toast.success(`Logged In Successfully`)
        navigate("/tvTerminal", { replace: true });
    }
}
const flowBackEndServices2 = {
    setUpSessionData, update2faPref,
    verifyMfaSSO,
    refreshLogin, getTotalMargin, setUpQrSessionData, getOptionUserPreferences, setUseroptionPreferences
    , getHistoricalOHLC, getFutures, getStrategies, getPayOff, getAvailableFunds, getBuilderStrategies, SsoLogin
};

export default flowBackEndServices2;
